import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ApiKey {
    id: number;
    userId: number;
    userName: string;
    name: string;
    prefix: string;
    key?: string;
    createdAt: string;
    lastUsedAt?: string;
    expiresAt?: string;
    revoked: boolean;
    active: boolean;
}

export interface NewApiKey {
    name: string;
    expiresAt?: string;
}

/** Aplicación conectada por OAuth (p. ej. Claude.ai o ChatGPT como conector MCP). */
export interface OAuthGrant {
    id: number;
    clientName: string;
    scope: string;
    createdAt: string;
    lastUsedAt?: string;
    expiresAt: string;
}

/**
 * API keys de la ExternalAPI / MCP del usuario logueado.
 */
@Injectable({
    providedIn: 'root'
})
export class ApiKeyService {

    private readonly url = '/ypm/api/external-admin/keys';
    private readonly grantsUrl = '/ypm/api/external-admin/oauth-grants';

    constructor(private _httpClient: HttpClient) {
    }

    getKeys(): Observable<ApiKey[]> {
        return this._httpClient.get<ApiKey[]>(this.url);
    }

    createKey(newKey: NewApiKey): Observable<ApiKey> {
        return this._httpClient.post<ApiKey>(this.url, newKey);
    }

    revokeKey(id: number): Observable<void> {
        return this._httpClient.delete<void>(this.url + '/' + id);
    }

    getOAuthGrants(): Observable<OAuthGrant[]> {
        return this._httpClient.get<OAuthGrant[]>(this.grantsUrl);
    }

    revokeOAuthGrant(id: number): Observable<void> {
        return this._httpClient.delete<void>(this.grantsUrl + '/' + id);
    }
}
